// Thank-you license table: the Windows / Mac switch points every Download button
// at that OS's installer and shows its file type and size. Starts on the visitor's
// OS, or the one last picked here or in the trial popup.

import { OS_KEY, detectOs } from './trial';

function selectOs(root, os) {
    root.querySelectorAll('[data-son-os]').forEach((tab) => {
        const active = tab.dataset.sonOs === os;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-son-download-windows]').forEach((link) => {
        link.href = os === 'mac' ? link.dataset.sonDownloadMac : link.dataset.sonDownloadWindows;
    });
    root.querySelectorAll('[data-son-file-windows]').forEach((cell) => {
        cell.textContent = os === 'mac' ? cell.dataset.sonFileMac : cell.dataset.sonFileWindows;
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-son-os-switch]').forEach((toggle) => {
        const root = toggle.closest('.son-thankyou__licenses');

        selectOs(root, detectOs());

        toggle.addEventListener('click', (event) => {
            const tab = event.target.closest('[data-son-os]');
            if (!tab) {
                return;
            }
            selectOs(root, tab.dataset.sonOs);
            try {
                window.sessionStorage.setItem(OS_KEY, tab.dataset.sonOs);
            } catch (e) {
                // storage blocked
            }
        });
    });
});
